import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import CustomButton from "../Buttons/Button";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import GridTable from "../table/gridTable";
import { individualInvestmentCloseOut } from "../../store/actions/investment/individualInvestmentCloseOut";

const ConfirmCloseOut = ({
  open,
  closeOutList,
  invID,
  type,
  refresh,
  onClose,
  onCloseParent,
  cycle,
}) => {
  const [loading, setLoading] = useState(false);

  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const dispatch = useDispatch();
  const columns = [
    {
      field: "firstName",
      headerName: "First Name",
      width: 150,
      renderCell: (params) =>
        params.row?.user
          ? params.row?.user.name?.split(" ")[0]
          : params.row?.name?.split(" ")[0],
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 150,
      renderCell: (params) =>
        params.row?.user
          ? params.row?.user.name?.split(" ")[1]
          : params.row?.name?.split(" ")[1],
    },

    {
      field: "Email",
      headerName: "Email",
      width: 300,
      // renderCell: (params) => percentage,
      renderCell: (params) =>
        params.row?.user ? params.row?.user.email : params.row?.email,
    },
  ];

  const handleClose = (beneficiaries) => {
    setLoading(true);

    let data = {};
    if (cycle) {
      data.cycle_id = cycle?.id;
      data.investment_product_id = cycle?.investment_id;
    }

    if (type === "Real Estate") {
      // dispatch(
      //   submitRealEstatePayout({
      //     data: {
      //       property_product_id: invID,
      //       disbursement_date: getServerDate(form?.values?.disbursement_date),
      //       profit_amount: form?.values?.profit_amount,
      //       repayment_type: form?.values?.repayment_type?.value,
      //       capital_amount: form?.values?.capital_amount,
      //       beneficiaries,
      //     },
      //     callback: () => {
      //       onCloseParent();
      //       dispatch(
      //         getRealEstatePayoutHistory({
      //           id: invID,
      //           callback: () => {},
      //           fail: () => {},
      //         }),
      //       );
      //       onClose(false);
      //     },
      //     fail: () => {
      //       setLoading(false);
      //     },
      //   }),
      // );
    } else {
      dispatch(
        individualInvestmentCloseOut({
          data: {
            user_ids: closeOutList.map((i) => i?.id),
            cycle_id: cycle?.id,
          },
          callback: () => {
            onCloseParent();
            refresh();
            onClose(false);
          },
          fail: () => {
            setLoading(false);
          },
        }),
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="custom-modal-title"
      aria-describedby="custom-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 800,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 3,
        }}
      >
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            top: 19,
            right: 10,
          }}
          onClick={onClose}
        >
          <ClearIcon />
        </IconButton>

        <div className="w-full ">
          <img src="/Assets/approveIcon.png" alt="" className="w-12 h-12 " />
          <div>
            <h1 className="font-semibold text-2xl mt-4 mb-4">Selected Users</h1>
            <p className="text-sm mb-4 w-[432px]">Review close out list</p>
            <div className="h-[270px] overflow-scroll w-full items-center mr-4">
              <GridTable
                noSearch={true}
                rows={closeOutList}
                columns={columns}
                disableRowSelectionOnClick={true}
              />
            </div>
            <div className="flex mt-4 w-full justify-center items-center">
              <CustomButton
                variant="outlined"
                customColor="#fff"
                children="Cancel"
                width="100%"
                onClick={onClose}
                height="50px"
                borderColor="#D0D5DD"
                margin="0px 20px 0px 0px"
                color="#159AA8"
                iconWidth="22px"
              />

              <CustomButton
                variant="contained"
                customColor="#159AA8"
                children="Submit"
                width="100%"
                loading={loading}
                height="50px"
                // disabled={rowSelectionModel?.length < 1}
                padding="10px"
                onClick={() => handleClose(rowSelectionModel)}
              />
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmCloseOut;
